require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./journal-armadale-residence-featured-on-habitus-living.json") })
        }
      }, "path---journal-armadale-residence-featured-on-habitus-living");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---journal-armadale-residence-featured-on-habitus-living!./.cache/json/journal-armadale-residence-featured-on-habitus-living.json
// module id = 455
// module chunks = 231608221292675